import { getMyEnv } from '@lessonnine/my.js';
import process from 'process';

import { LOCALE_SUBDOMAIN_MAPPING } from 'src/dataLayer/localData/localeMapping.ts';

const {
  apigatewayBaseUrl,
  awsSessionEndpoint,
  awsSessionMethod,
  assetUrl,
  environment,
  geoData,
  goBaseUrl,
  locale,
  myBaseUrl,
  homeBaseUrl,
  rollbarAccessToken,
  client,
  signInUrl,
  staticBaseUrlTemplate,
  uuid
} = getMyEnv();

export const APIGATEWAY_BASE_URL = apigatewayBaseUrl;
export const ASSET_URL = assetUrl;
export const AWS_SESSION_ENDPOINT = awsSessionEndpoint;
export const AWS_SESSION_METHOD = awsSessionMethod;
export const DASHBOARD_URL = `${myBaseUrl}/dashboard`;
export const GEO_DATA = geoData;
export const GO_BASE_URL = goBaseUrl;
export const LOCALE = locale;
export const ROLLBAR_ACCESS_TOKEN = rollbarAccessToken;
export const ROLLBAR_API_URL = 'https://api.rollbar.com/api/1/item/';
export const RUNTIME_ENVIRONMENT = environment;
export const TRACKING_URL = `${APIGATEWAY_BASE_URL}/v1/events`;
export const UUID = uuid;
export const CLIENT = client;
export const SIGN_IN_URL = signInUrl;
export const ECOSYSTEM_URL = `${myBaseUrl}/ecosystem/live-and-core`;
export const CAPTCHA_CONFIG_URL = `${ APIGATEWAY_BASE_URL }/v1/captcha/signup`;

// Buildtime
export const { BABBEL_APP_VERSION } = process.env;

// GLOBAL
export const DEFAULT_FLOW_ID = 'default';
export const FLOW_ID_WITHOUT_L2 = 'language_selection';

// BUILT URLS
export const getIndexPageURL = () => {
  const subdomain = LOCALE_SUBDOMAIN_MAPPING[LOCALE];
  return staticBaseUrlTemplate.replace('%{subdomain}', subdomain);
};

export const getOauthSignupURL = (provider, returnTo) =>
  `${homeBaseUrl}/${LOCALE}/oauth_session/new?provider=${provider}&return_to=${returnTo}`;

export const getLivePricePageURL = () => `${myBaseUrl}/${LOCALE}/prices/live`;

export const buildCourseOverviewURL = (learnLang, courseUuid) =>
  `${myBaseUrl}/course-overview/${LOCALE}/deep_dive/${learnLang}/course_overviews/${courseUuid}`;
